$(document).ready(function () {
    $('.custom-tab-navigation a').on('click', function () {
        var tabId = $(this).data('tab');
        $('.custom-tab-navigation a').removeClass('active');
        $(this).addClass('active');
        $('.custom-tab-panel').hide();
        $('#' + tabId).show();
        if ($('.custom-product-grid').hasClass('slick-initialized')) {
            $('.custom-product-grid').slick('unslick');
        }
        tabSlider();
    });
    $('.custom-tab-navigation a:first').addClass('active').click();
    function tabSlider() {
        var $slider = $('.custom-product-grid');
        $slider.slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"></path></svg></div>',
    nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"></path></svg></div>',
     
            responsive: [
                {
                    breakpoint: 989,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
});

// related articles on blog page
$('.dib-related-posts').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
     swipeToSlide: true,
     arrows:true,
     prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"></path></svg></div>',
      nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"></path></svg></div>',
       
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Scroll back to top button
  jQuery(document).ready(function() {
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 300) {
            jQuery('#back-to-top-button').fadeIn();
        } else {
            jQuery('#back-to-top-button').fadeOut();
        }
    });
    jQuery('#back-to-top-button').click(function() {
        jQuery('html, body').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});
  
$(document).ready(function(){
	$(".cart-item").each(function() {
		let productId = $(this).data("productid");
		let productIdsToCheck = [29692900442191, 29950593597519, 12451019161679];
		if (productIdsToCheck.includes(Number(productId))) {
		    $(this).addClass("noClick");
		}
	});
});



// --- Sticky Add to Cart Logic ---
$(document).ready(function () {
    var $stickyAddToCart = $('#sticky-add-to-cart');
    var $mainAddToCart = $('.product-form__submit').first();

    if ($stickyAddToCart.length && $mainAddToCart.length) {
        function checkSticky() {
            var btnBottom = $mainAddToCart.offset().top + $mainAddToCart.outerHeight();
            if ($(window).scrollTop() > btnBottom) {
                $stickyAddToCart.addClass('show');
            } else {
                $stickyAddToCart.removeClass('show');
            }
        }

        $(window).on('scroll', checkSticky);
        checkSticky(); // check initially

        // Handle sticky add to cart button click
        $('#sticky-add-to-cart-btn').on('click', function () {
            $mainAddToCart.click();
        });
    }
});

/* Sticky filter bar */
(function() {
  var filterBar = document.getElementById('main-collection-filters');
  if (!filterBar) return;

  /* Remove parent section padding-top so filter sits flush under header */
  var sectionPadding = filterBar.closest('[class*="section-"][class*="-padding"]');
  if (sectionPadding) {
    sectionPadding.style.paddingTop = '0px';
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      filterBar.classList.toggle('is-stuck', !entry.isIntersecting);
    });
  }, { threshold: [1], rootMargin: '-1px 0px 0px 0px' });

  var sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  sentinel.style.marginBottom = '-1px';
  filterBar.parentNode.insertBefore(sentinel, filterBar);
  observer.observe(sentinel);
})();

